<template>
    <div>
        <NimbusCustomerSupportContainer />

        <NimbusCompanyInformationPanel />
    </div>
</template>
